function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-966d36ab-f5bf-4a29-809a-f07dcd6ee07d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m6.201,28.639c-1.231,0-1.79-.347-2.142-.698h0c-.537-.537-1.062-1.557-.361-4.707.161-.723.756-3.153,1.659-4.056L20.553,3.982c1.35-1.349,3.702-1.349,5.051,0l2.414,2.414c1.392,1.393,1.392,3.658,0,5.051l-15.196,15.195c-.903.903-3.332,1.499-4.055,1.659-1.085.242-1.918.337-2.565.337Zm.187-2.502h0ZM23.078,5.936c-.088,0-.259.022-.404.167l-15.195,15.196c-.396.541-1.074,3.104-1.123,4.344,1.242-.048,3.811-.733,4.392-1.165l15.148-15.152c.223-.223.223-.585,0-.809l-2.414-2.414c-.146-.146-.316-.167-.404-.167ZM5.863,25.612h0Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdited);
export default __webpack_public_path__ + "static/media/Edited.9569c3fd4b7f6df0e301da9b3d9ebb46.svg";
export { ForwardRef as ReactComponent };